import { Configuration, ApiConfigOptions } from '@sg/api/base-api-lib';

export interface LegalEntitiesApiConfigOptions extends ApiConfigOptions {}
export class LegalEntitiesApiConfig extends Configuration {
  constructor(configOptions?: LegalEntitiesApiConfigOptions) {
    super({ ...{}, ...(configOptions || {}) });
  }
}
